import { Filters } from './AccommodationsConsole.types';

export const PRICE_RANGE = {
  MIN: 0,
  MAX: 1000
} as const;

export const DEFAULT_FILTERS: Filters = {
  facilities: [],
  starRating: [],
  userRating: [],
  priceRange: [PRICE_RANGE.MIN, PRICE_RANGE.MAX],
  pickedByCouple: false
};
